import { useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { api, formatApiError } from "../api";
import { useLang } from "../i18n";
import { Input } from "../components/ui/input";
import { Button } from "../components/ui/button";
import { Label } from "../components/ui/label";

export default function ResetPasswordPage() {
  const { t } = useLang();
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [state, setState] = useState("form");
  const [error, setError] = useState(null);

  const submit = async (e) => {
    e.preventDefault();
    setError(null);
    try {
      await api.post("/auth/reset-password", { token, password });
      setState("done");
    } catch (err) {
      setError(formatApiError(err));
    }
  };

  return (
    <div data-testid="reset-password-page" className="mx-auto flex max-w-md flex-col px-4 py-20">
      <div className="rounded-2xl border bg-white p-8 shadow-sm">
        <h1 className="font-heading text-2xl font-bold">{t("reset.title")}</h1>
        {state === "done" ? (
          <div className="mt-4">
            <p data-testid="reset-success-message" className="text-sm text-emerald-700">{t("reset.success")}</p>
            <Link to="/logowanie" className="mt-3 inline-block text-sm font-semibold text-[#DC143C] hover:underline">
              {t("nav.login")} →
            </Link>
          </div>
        ) : (
          <form onSubmit={submit} className="mt-6 space-y-4">
            <div>
              <Label htmlFor="reset-password">{t("auth.password")}</Label>
              <Input
                id="reset-password"
                data-testid="reset-password-input"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                minLength={8}
                className="mt-1.5"
              />
            </div>
            {error && (
              <p data-testid="reset-error-message" className="rounded-lg border border-rose-200 bg-rose-50 px-3 py-2 text-sm text-rose-700">
                {error}
              </p>
            )}
            <Button data-testid="reset-submit-button" type="submit" className="h-11 w-full bg-[#DC143C] text-white hover:bg-[#B91C1C]">
              {t("reset.submit")}
            </Button>
          </form>
        )}
      </div>
    </div>
  );
}
